import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE = 'https://goleicestershire.com';

// One canonical URL per page: always the production domain, no query strings,
// no trailing slash — so www/non-www, preview domains and tracking params
// never register as duplicate pages with Google.
export default function CanonicalTag() {
  const { pathname } = useLocation();
  // The static FAQPage block in index.html is homepage-only: neutralise its
  // type on other routes so rendered crawlers don't see FAQ markup site-wide.
  React.useEffect(() => {
    const el = document.getElementById('faq-schema');
    if (el) el.type = pathname === '/' ? 'application/ld+json' : 'application/json';
  }, [pathname]);
  if (pathname.startsWith('/admin')) return null;
  const clean = pathname.replace(/\/+$/, '') || '/';
  return (
    <Helmet>
      <link rel="canonical" href={clean === '/' ? `${BASE}/` : `${BASE}${clean}`} />
    </Helmet>
  );
}
